module.exports = __webpack_public_path__ + "img/47.4.NH3-N.8793cf66.png";